module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-latin610.429ddd9.woff2";